export const CODE_BADGE_CLASS =
  'rounded-md bg-muted px-2 py-0.5 text-xs font-medium uppercase tracking-wide tabular-nums';
